import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { BrProfileNavigationWrapperWC } from '@juliusbaer-gcrm/pcm-br-purpose-components';
import { BrTabItems } from 'views/BrTabs/BrTabs';
import { ProfilingSection } from 'views/BrTabs/components/ProfilingSections/ProfilingSection';
import { useRuntimeConfig } from 'config/useRuntimeConfig';
import { NavigationWizardSectionRenderParams } from 'views/BrTabs/types/navigationWizardMode';

export function BrPurposeSection({ selectedTab, navigateToTab }: NavigationWizardSectionRenderParams): ReactNode {
  const { t } = useTranslation();
  const runtimeConfig = useRuntimeConfig();
  const isActive = selectedTab === BrTabItems.BR_PURPOSE;
  return ProfilingSection({
    tabId: BrTabItems.BR_PURPOSE,
    title: t('navigationWizard.item.title.brPurpose'),
    isActive,
    onSectionSelect: () => navigateToTab(BrTabItems.BR_PURPOSE),
    children: (
      <BrProfileNavigationWrapperWC
        env={runtimeConfig.envInfo.envId}
        version="0.0.1"
        onSectionSelect={() => navigateToTab(BrTabItems.BR_PURPOSE)}
        isActive={isActive}
      />
    ),
  });
}
